import React from 'react';
import { Link } from 'react-router';

import { Button as RadixButton } from '@radix-ui/themes';
import classNames from 'classnames';

import { getFlyToRadixColor, renderIcon } from '../utils';
import {
  ButtonProps,
  iconSizeMap,
  radiusMap,
  sizeToRadixSizeMap,
  sizeToStyleMap,
} from './Button.types';

function Button({
  color = 'accent',
  size = '2',
  radius = 'medium',
  to,
  href,
  target,
  type = 'button',
  iconStart,
  iconEnd,
  iconSize = iconSizeMap[size],
  children,
  noHoverEffect,
  className,
  ref,
  ...props
}: ButtonProps & { ref?: React.Ref<HTMLButtonElement> }) {
  const innerContent = (
    <>
      {iconStart && <div>{renderIcon(iconStart, iconSize)}</div>}
      {children}
      {iconEnd && <div>{renderIcon(iconEnd, iconSize)}</div>}
    </>
  );

  let content = innerContent;
  if (to) {
    content = <Link to={to}>{innerContent}</Link>;
  }
  if (href) {
    content = (
      <a href={href} target={target}>
        {innerContent}
      </a>
    );
  }

  return (
    <RadixButton
      className={classNames(
        'font-semibold box-border flex items-center gap-fly-2',
        radiusMap[`${size}-${radius}`],
        sizeToStyleMap[size],
        props.variant === 'ghost' && 'm-0',
        noHoverEffect &&
          'hover:bg-transparent! active:bg-transparent! data-[state=open]:bg-transparent!',
        className
      )}
      asChild={!!to || !!href}
      size={sizeToRadixSizeMap[size]}
      color={getFlyToRadixColor(color)}
      type={type}
      {...props}
      ref={ref}
    >
      {content}
    </RadixButton>
  );
}

export { Button };
